import { render, staticRenderFns } from "./CommissionerLandingPage.vue?vue&type=template&id=6d81a6d1"
import script from "./CommissionerLandingPage.vue?vue&type=script&lang=js"
export * from "./CommissionerLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports